import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "aos/dist/aos.css";
import "remixicon/fonts/remixicon.css";
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer theme="dark" position="top-right" autoClose={3000} closeOnClick pauseOnHover={false} />
    <App />
  </React.StrictMode>
);